import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Chip,
  CircularProgress,
  ClickAwayListener,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import DoneIcon from '@material-ui/icons/Done';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DateFnsUtils from '@date-io/date-fns';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import InsertInvitationRoundedIcon from '@material-ui/icons/InsertInvitationRounded';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { CSVLink } from 'react-csv';
import { Alert } from '@material-ui/lab';
import { FaFileExport } from 'react-icons/fa6';
import { leadsActions } from '../../store/leads-reducer';
import LeadsTableRow from './LeadsTableRow';
import useStyles from './LeadsFullView.style';
import StyledActiveChip from '../../customUI/ActiveChip';
import {
  StyledTableHeadCell,
  StyledTableHeadCell1,
  StyledTableHeadCell2,
  StyledTablePagination,
} from '../../customUI/table/TableStyles';
import StyledSearchChip from '../../customUI/SearchChip';
import MobileTitle from '../../customUI/MobileTitle';
import MobileLeadsCard from './MobileLeadsCard';
import BlueButton from '../../customUI/BlueButton';
import { storeContext } from '../provider/Provider';
import CustomSortIcon from '../common/CustomSortIcon';
import { trimStartString } from '../../functions';

const { REACT_APP_FLASK_API_URL } = process.env;

const LeadsFullView = () => {
  const classes = useStyles();
  const { state, dispatch } = React.useContext(storeContext);
  let isPhone = false;
  const csvLinkRef = useRef(null);
  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }

  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [openNewLead, setOpenNewLead] = useState(false);
  const [search, setSearch] = useState('');
  const [mobileDate, setMobileDate] = useState(false);
  const [tableBodyHeight, setTableBodyHeight] = useState(300);
  const [isInternalFetching, setIsInternalFetching] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [exportClicked, setExportClicked] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportSuccess, setExportSuccess] = useState(false);
  const [exportError, setExportError] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [orderBy, setOrderBy] = useState('-updated_at');
  const [filterBy, setFilterBy] = useState(null);

  const handleOrderByClick = (value) => {
    if(value === orderBy) {
      setOrderBy(`-${value}`);
      return;
    }

    setOrderBy(value);
  }

  const handleTooltipOpen = () => {
    setTooltipOpen(true);
  };

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  const handleFilterByClick = (value) => {
    setFilterBy(value);
    setTimeout( () => handleTooltipClose(), 100);
  };

  useEffect(() => {
    if(state.leads.markedLeadsToExport.length>0 && exportClicked){
        setExportClicked(false); 
        csvLinkRef.current.link.click();
      }
  }, [state.leads.markedLeadsToExport]);


  const fetchDataAndDwnloadCSV = async () => {
    const newStatus = state.leads.currentStatus;

    let fromDateExpression = '';
    if (fromDate !== null && toDate !== null) {
      fromDateExpression = `&dateFrom=${
        fromDate.getMonth() + 1
      }-${fromDate.getDate()}-${fromDate.getFullYear()}`;
    }
    
    let toDateExpression = '';
    if (toDate !== null) {
      toDateExpression = `&dateTo=${
        toDate.getMonth() + 1
      }-${toDate.getDate()}-${toDate.getFullYear()}`;
    }

    let typeFiltering='marked_as_lead=true';

    if(filterBy){
      typeFiltering= `&chat=${filterBy === 'chat'}`;
    }

    let orderByParam='';
    if(orderBy){
      orderByParam=`&ordering=${orderBy}`
    }

    setExportLoading(true);
    axios
    .get(
      `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/${newStatus}/1/10000${typeFiltering || orderByParam || fromDateExpression || toDateExpression ? '?' : ''}${typeFiltering}${orderByParam}${fromDateExpression}${toDateExpression}`
    )
    .then((res) => {
      setExportClicked(true)
      dispatch({
        type: leadsActions.MARKED_LEADS_SET_EXPORT,
        payload: {
          markedLeadsToExport: res.data.data.leads.map((lead) => ({
            ...lead,
            leadBody: {
              ...lead.leadBody,
              message: lead.leadBody.message? lead.leadBody.message.replace(/\r\n/g, " "): lead.leadBody.message
            }
          }))
        },
      });
      
      setExportSuccess(true);
      setExportLoading(false);
    }).catch(() => {
      setExportError(true);
      setExportLoading(false);
    });
  };

  const handleExportAlertClosed = () => {
    setExportSuccess(false);
    setExportError(false);
  }

  const updateRows = (page, perPage, status = '') => {
    setIsInternalFetching(true);
    if (document.getElementById('tableBody')) {
      setTableBodyHeight(
        document.getElementById('tableBody').clientHeight > 300
          ? document.getElementById('tableBody').clientHeight
          : 300
      );
    }
    let newStatus = state.leads.currentStatus;
    if (status) {
      if (status === 'all') {
        newStatus = '';
      } else {
        newStatus = status;
      }
    }
    let fromDateExpression = '';
    if (fromDate !== null && toDate !== null) {
      fromDateExpression = `&dateFrom=${
        fromDate.getMonth() + 1
      }-${fromDate.getDate()}-${fromDate.getFullYear()}`;
    }
    
    let toDateExpression = '';
    if (toDate !== null) {
      toDateExpression = `&dateTo=${
        toDate.getMonth() + 1
      }-${toDate.getDate()}-${toDate.getFullYear()}`;
    }

    let typeFiltering='marked_as_lead=true';
    
    if(filterBy){
      typeFiltering= `chat=${filterBy === 'chat'}`;
    }

    let orderByParam='';
    if(orderBy){
      orderByParam=`&ordering=${orderBy}`
    }

    if (!state.leads.isSearching && fromDateExpression !== '' && toDateExpression !== '') {
      if (newStatus === '') {
        newStatus = 'all';
      }
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/${newStatus}/${page}/${perPage}${typeFiltering || orderByParam || fromDateExpression || toDateExpression ? '?' : ''}${typeFiltering}${orderByParam}${fromDateExpression}${toDateExpression}`
        )
        .then((res) => {
          dispatch({
            type: leadsActions.LEADS_SET_ALL,
            payload: {
              isFetching: false,
              total: res.data.data.total,
              leads: res.data.data.leads,
            },
          });
          setIsInternalFetching(false);
        });
    } else {
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/${newStatus}/${page}/${perPage}${typeFiltering || orderByParam ? '?' : ''}${typeFiltering}${orderByParam}`
        )
        .then((res) => {
          dispatch({
            type: leadsActions.LEADS_SET_ALL,
            payload: {
              isFetching: false,
              total: res.data.data.total,
              leads: res.data.data.leads,
            },
          });
          setIsInternalFetching(false);
        });
    }
  };

  useEffect(() => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        isFetching: false,
      },
    });

    updateRows(1, state.leads.perPage);
  }, [orderBy, filterBy, fromDate, toDate]);

  const handleOpen = () => {
    setOpenNewLead(true);
  };

  const handleClose = () => {
    setOpenNewLead(false);
  };

  const handleSwitchStatus = (newStatus) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentStatus: newStatus,
        currentPage: 0,
      },
    });
    updateRows(1, state.leads.perPage, newStatus);
  };

  const handleChangePage = (event, newPage) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentPage: newPage,
      },
    });
    updateRows(newPage + 1, state.leads.perPage);
  };

  const handleUnSearch = () => {
    setIsInternalFetching(true);
    setSearch('');
    axios
      .get(
        `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/${state.leads.currentStatus}/1/${state.leads.perPage}`
      )
      .then((res) => {
        setIsInternalFetching(false);
        dispatch({
          type: leadsActions.LEADS_SET_ALL,
          payload: {
            isSearching: false,
            searchKeyword: '',
            total: res.data.data.total,
            leads: res.data.data.leads,
            currentPage: 0,
          },
        });
      });
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        perPage: parseInt(event.target.value, 10),
        currentPage: 0,
      },
    });
    updateRows(1, parseInt(event.target.value, 10));
  };

  const handleSearch = () => {
    if (search) {
      setIsInternalFetching(true);
      setFromDate(null);
      setToDate(null);
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          isSearching: true,
          searchKeyword: search,
        },
      });
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/${state.leads.currentStatus}/1/${state.leads.perPage}?marked_as_lead=true&ordering=-updated_at&search=${search}`
        )
        .then((res) => {
          dispatch({
            type: leadsActions.LEADS_SET_ALL,
            payload: {
              isFetching: false,
              total: res.data.data.total,
              leads: res.data.data.leads,
            },
          });
          setIsInternalFetching(false);
        });
    }
  };

  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };
  const handleFromDateChange = (date) => {
    if (date) {
      setFromDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          currentPage: 0,
        },
      });
    }
  };
  const handleToDateChange = (date) => {
    if (date) {
      setToDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          currentPage: 0,
        },
      });
    }
  };
  const handleDeleteDate = () => {
    setFromDate(null);
    setToDate(null);

    updateRows(1, state.leads.perPage);
  };

  const handleOpenDate = () => {
    setMobileDate(true);
  };

  const handleOpenSearch = () => {
    if (document.getElementById('mobileSearch').classList.contains('open')) {
      document.getElementById('mobileSearch').classList.toggle('open');
      setTimeout(() => {
        document
          .getElementById('mobileSelect')
          .parentElement.parentElement.classList.toggle('openSearch');
      }, 500);
    } else {
      document
        .getElementById('mobileSelect')
        .parentElement.parentElement.classList.toggle('openSearch');
      setTimeout(() => {
        document.getElementById('mobileSearch').classList.toggle('open');
      }, 500);
    }
  };

  const submitNewLead = () => {
    const data = {
      website: state.websiteSwitch.currentWebsite,
      fullName,
      email,
      phone,
    };
    axios.post(`${REACT_APP_FLASK_API_URL}/put-lead`, data).then(() => {
      updateRows(1, state.leads.perPage);
      handleClose();
    });
  };

  if (state.leads.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }

  if (isPhone) {
    return (
      <>
        <MobileTitle title="Leads" />
        <div className={classes.flex__container} id="mobileHeader">
          <TextField
            fullWidth
            className={classes.select}
            id="mobileSelect"
            defaultValue="all"
            value={state.leads.currentStatus}
            variant="outlined"
            select
            SelectProps={{
              IconComponent: KeyboardArrowDownIcon,
            }}
          >
            <MenuItem key={1} value="all" onClick={() => handleSwitchStatus('all')}>
              All
            </MenuItem>
            <MenuItem key={2} value="won" onClick={() => handleSwitchStatus('won')}>
              Won
            </MenuItem>
            <MenuItem key={3} value="lost" onClick={() => handleSwitchStatus('lost')}>
              Lost
            </MenuItem>
          </TextField>
          <div className={classes.searchInputFlex} id="mobileSearch">
            <TextField
              id="search-field"
              placeholder="Start Typing"
              className={classes.searchInput}
              value={search}
              aria-label="search field"
              onKeyPress={handleKeypress}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              variant="standard"
            />
            {state.leads.isSearching && (
              <StyledSearchChip
                className={classes.chipMargin}
                label={`Search: ${search}`}
                aria-label="unSearch button"
                onDelete={handleUnSearch}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
          </div>
          <p className={classes.fullViewIcons}>
            <SearchIcon onClick={handleOpenSearch} />
          </p>
          <p className={classes.fullViewIcons}>
            <InsertInvitationRoundedIcon onClick={handleOpenDate} />
          </p>
          <Dialog
            open={mobileDate}
            className={classes.datePopup}
            onClose={() => {
              setMobileDate(false);
            }}
          >
            <DialogTitle id="form-dialog-title">
              Please select the dates to filter the pages.
            </DialogTitle>
            <div className={classes.dateInputFlex}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  // openTo="year"
                  // views={['year', 'month', 'day']}
                  label="From"
                  value={fromDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleFromDateChange}
                  aria-label="from date picker"
                />
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  // openTo="year"
                  // views={['year', 'month']}
                  label="To"
                  value={toDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleToDateChange}
                />
              </MuiPickersUtilsProvider>
            </div>
          </Dialog>
        </div>
        {state.leads.total && !isInternalFetching ? (
          <div>
            {state.leads.leads.map((row) => (
              <MobileLeadsCard row={row} />
            ))}
          </div>
        ) : (
          <>{!isInternalFetching && <div style={{ margin: '5% 0 0 5%' }}>No results</div>}</>
        )}
        {isInternalFetching && (
          <div className={classes.loading} style={{ height: 400 }}>
            <CircularProgress />
          </div>
        )}
        {!state.leads.isSearching && (
          <StyledTablePagination
            rowsPerPageOptions={[15, 50]}
            component="div"
            count={state.leads.total}
            rowsPerPage={state.leads.perPage}
            page={state.leads.currentPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Rows:"
          />
        )}
      </>
    );
  }

  return (
    <div className={classes.wrapper}>
      <Dialog open={openNewLead} onClose={handleClose} className={classes.addLeadPopup}>
        <DialogTitle>New Lead</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email Address"
            fullWidth
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="full name"
            label="Full Name"
            fullWidth
            value={fullName}
            onChange={(e) => {
              setFullName(e.target.value);
            }}
          />
          <TextField
            margin="dense"
            id="phone"
            label="Phone"
            fullWidth
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
            }}
          />
          <div className={classes.leadsButtons}>
            <BlueButton aria-label="Add new lead" onClick={submitNewLead}>
              Submit
            </BlueButton>
            <BlueButton aria-label="Close" onClick={handleClose}>
              Cancel
            </BlueButton>
          </div>
        </DialogContent>
      </Dialog>
      <div className={classes.card}>
        <div className={classes.card__wrapper}>
          <div className={classes.card__header}>
            <div style={{ width: '100%', justifyContent: 'flex-start', }}>
              <div className={classes.heading}>All Leads</div>
              {!state.leads.isSearching && (
                <>
                  {state.leads.currentStatus === 'all' ? (
                    <StyledActiveChip label="All" className={classes.chipMargin} />
                  ) : (
                    <Chip
                      className={classes.chipMargin}
                      label="All"
                      clickable
                      onClick={() => handleSwitchStatus('all')}
                    />
                  )}
                  {state.leads.currentStatus === 'won' ? (
                    <StyledActiveChip
                      label="Won"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('all')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <Chip
                      className={classes.chipMargin}
                      label="Won"
                      clickable
                      onClick={() => handleSwitchStatus('won')}
                    />
                  )}
                  {state.leads.currentStatus === 'lost' ? (
                    <StyledActiveChip
                      label="Lost"
                      className={classes.chipMargin}
                      onDelete={() => handleSwitchStatus('all')}
                      deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                    />
                  ) : (
                    <Chip
                      className={classes.chipMargin}
                      label="Lost"
                      clickable
                      onClick={() => handleSwitchStatus('lost')}
                    />
                  )}
                  {fromDate && !toDate && (
                    <StyledActiveChip
                      label={`From ${fromDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${fromDate.getFullYear()}`}
                      className={classes.chipMargin}
                      onDelete={handleDeleteDate}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                    />
                  )}
                  {!fromDate && toDate && (
                    <StyledActiveChip
                      label={`From ${toDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${toDate.getFullYear()}`}
                      className={classes.chipMargin}
                      onDelete={handleDeleteDate}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                    />
                  )}
                  {fromDate && toDate && (
                    <StyledActiveChip
                      label={`${fromDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${fromDate.getFullYear()} - ${toDate.toLocaleString('en-US', {
                        month: 'long',
                      })} ${toDate.getFullYear()}`}
                      className={classes.chipMargin}
                      onDelete={handleDeleteDate}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                    />
                  )}
                  {filterBy && (
                    <StyledActiveChip
                      label={`${filterBy}`}
                      className={classes.chipMargin}
                      onDelete={()=> setFilterBy(null)}
                      deleteIcon={<ClearIcon style={{ color: 'white' }} />}
                      style={{
                        textTransform: 'capitalize'
                      }}
                    />
                  )}
                </>
              )}
            </div>
            <div className={classes.searchInputFlex}>
              <BlueButton
                aria-label="Add new lead"
                onClick={handleOpen}
                className={classes.leadButton}
              >
                Add Lead
              </BlueButton>
              {state.leads.isSearching && (
                <StyledSearchChip
                  className={classes.chipMargin}
                  label={`Search: ${state.leads.searchKeyword}`}
                  onDelete={handleUnSearch}
                  deleteIcon={<DoneIcon style={{ color: 'white' }} />}
                />
              )}
              <TextField
                id="search-field"
                placeholder="Start Typing"
                className={classes.searchInput}
                onKeyPress={handleKeypress}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton style={{ padding: 3 }} onClick={handleSearch}>
                        <SearchIcon style={{ color: 'grey' }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                variant="standard"
              />
            </div>
          </div>
          <div className={classes.card__header}>
            <div style={{ width: '100%', justifyContent: 'flex-start', }} className={classes.searchInputFlex}>
              <Box style={{ marginLeft: 15, marginRight: 10}}>Filter By Date</Box>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  // openTo="year"
                  // views={['year', 'month']}
                  label="From"
                  value={fromDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleFromDateChange}
                  aria-label="from date picker"
                />
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  // openTo="year"
                  // views={['year', 'month']}
                  label="To"
                  value={toDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleToDateChange}
                />
              </MuiPickersUtilsProvider>
            </div>
            {!state.leads.isSearching && (<div
              aria-hidden="true"
              aria-label="exportButton"
              onClick={() => fetchDataAndDwnloadCSV()}
              style={{
                color: '#00B5E2',
                fontSize: '1.2rem',
                marginLeft: '20px', 
                marginRight: '10px',
              }}>
                <Box display="flex">
                  <Box mr="3px">
                    <FaFileExport />
                  </Box>
                  <Box width="120px">
                    Export to csv
                  </Box>
                  {exportLoading && <CircularProgress size={20} style={{marginLeft: 5}} />}
                </Box>
            </div>)}
            <CSVLink
              data={state.leads.markedLeadsToExport}
              headers={[
                { label: 'Uuid', key: 'uuid'},
                { label: 'Created at', key: 'createdAt'},
                { label: 'Updated at', key: 'updatedAt'},
                { label: 'Conversion Url', key: 'leadBody.conversionUrl' },
                { label: 'Email', key: 'leadBody.email' },
                { label: 'Full Name', key: 'leadBody.fullName' },
                { label: 'Landing Url', key: 'leadBody.landingUrl' },
                { label: 'Message', key: 'leadBody.message' },
                { label: 'Phone', key: 'leadBody.phone' },
                { label: 'Referrer Url', key: 'leadBody.referrerUrl' },
                { label: 'Website', key: 'leadBody.website' },
                { label: 'Status', key: 'status'},
              ]}
              filename={`fls_${state.websiteSwitch.currentWebsite}.csv`}
              ref={csvLinkRef}
              style={{
                display: 'none'
              }}
            >
              Export to CSV
            </CSVLink>
            <Snackbar
              open={exportSuccess || exportError}
              autoHideDuration={6000}
              onClose={handleExportAlertClosed}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              key="bottom left"
            >
              {exportSuccess ? (
                <Alert onClose={handleExportAlertClosed} severity="success">
                  Data fetched successfully!
                </Alert>
              ) : (
                <Alert onClose={handleExportAlertClosed} severity="error">
                  Error parsing data!
                </Alert>
              )}
            </Snackbar>
          </div>

          {state.leads.total ? (
            <div className={classes.leadTable}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableHeadCell1 style={{ position: 'relative', cursor: 'pointer' }}>
                      <Box display='flex' flex={1} justifyContent='space-between'>
                        Date
                      </Box>
                    </StyledTableHeadCell1>
                    <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleOrderByClick('fullName')}>
                      <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                        Name
                        <CustomSortIcon field='fullName' column={trimStartString(orderBy, '-')} type={orderBy === 'fullName'? 'asc': 'desc'} />
                      </Box>
                    </StyledTableHeadCell>
                    <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} onClick={handleTooltipOpen}>
                      <Box display='flex' flex={1} justifyContent='space-between'>
                        Type
                        <Box borderRadius='5px' border="1px solid grey" lineHeight='0.9em'><ArrowDropDownIcon /></Box>
                      </Box>
                      {tooltipOpen && (
                        <ClickAwayListener onClickAway={handleTooltipClose}>
                        <Box
                        style={{
                          color: 'white',
                          padding: '15px 10px',
                          position: 'absolute',
                          left: '0',
                          top: '40px',
                          width: '100px',
                          background: 'rgba(0,0,0,.6)',
                          borderRadius: '15px',
                        }}
                      >
                        <Box p='4px 8px' style={{
                          background: !filterBy ? 'rgba(255,255,255,.3)' : 'none',
                        }} onClick={() => handleFilterByClick(null)}>All</Box>
                        <Box p='4px 8px' style={{
                          background: filterBy === 'form' ? 'rgba(255,255,255,.3)' : 'none',
                        }} onClick={() => handleFilterByClick('form')}>Form</Box>
                        <Box p='4px 8px' style={{
                          background: filterBy === 'chat' ? 'rgba(255,255,255,.3)' : 'none',
                        }} onClick={() => handleFilterByClick('chat')}>Chat</Box>
                      </Box>
                      </ClickAwayListener>)}
                    </StyledTableHeadCell>                   
                    <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} >
                      Channel
                    </StyledTableHeadCell>
                    <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleOrderByClick('email')}>
                      <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                        Email
                        <CustomSortIcon field='email' column={trimStartString(orderBy, '-')} type={orderBy === 'email'? 'asc': 'desc'} />
                      </Box>
                    </StyledTableHeadCell>
                    <StyledTableHeadCell>Form Review</StyledTableHeadCell>
                    <StyledTableHeadCell>Chat Transcripts</StyledTableHeadCell>
                    <StyledTableHeadCell2 align="center">Action</StyledTableHeadCell2>
                  </TableRow>
                </TableHead>
                {!isInternalFetching && (
                  <TableBody>
                    {state.leads.leads.map((row) => (
                      <LeadsTableRow row={row} key={row.uuid} />
                    ))}
                  </TableBody>
                )}
              </Table>
            </div>
          ) : (
            <>
              {!isInternalFetching && (
                <div className={classes.noContentBlock}>
                  <span>No Results</span>
                </div>
              )}
            </>
          )}
        </div>
        {isInternalFetching && (
          <div className={classes.loading} style={{ height: tableBodyHeight }}>
            <CircularProgress />
          </div>
        )}
        {!state.leads.isSearching && (
          <>
            <Divider />
            <div className={classes.card__wrapper}>
              <div className={classes.cardActionButton} aria-hidden="true">
                <StyledTablePagination
                  rowsPerPageOptions={[15, 50]}
                  component="div"
                  count={state.leads.total}
                  rowsPerPage={state.leads.perPage}
                  page={state.leads.currentPage}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LeadsFullView;
